import { useSession } from '@shared/auth';
import { Button, Skeleton } from '@shared/components/shadcn';
import { Close, Success } from '@shared/icons';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useGlobalSheet } from '../../../../context/GlobalSheetContext';
import type { FormData, SuccessStepProps } from '../../types';

function SuccessStep({ namespace, onClose, ...props }: SuccessStepProps) {
  const { watch } = useFormContext<FormData>();
  const { session, isLoading } = useSession();
  const playerProfile = session.profile;
  const amount = watch('amountStep.amount');
  const { hideDepositSheetHeader } = useGlobalSheet();
  const t = useTranslations(`${namespace}.success_step`);

  useEffect(() => {
    hideDepositSheetHeader();
  }, [hideDepositSheetHeader]);

  return (
    <div className="flex flex-col gap-8" {...props}>
      <div className="flex gap-3 items-center">
        <div className="flex items-center justify-center w-10 h-10 bg-accent-green rounded-full shrink-0">
          <Success className="text-foreground light" size="medium" data-testid="success-icon" />
        </div>
        <div className="flex flex-col w-full">
          {isLoading ? (
            <div className="flex flex-col gap-2">
              <Skeleton className="h-6 w-full"></Skeleton>
              <Skeleton className="h-4 w-full"></Skeleton>
            </div>
          ) : (
            <>
              <h5>
                {t('title')} <span data-track-privacy="Mask">{playerProfile?.firstName || ''}</span> 🤞
              </h5>
              <p className="paragraph-s">{t('description', { amount })}</p>
            </>
          )}
        </div>
        {/* Close button here */}
        <div className="grow"></div>
        <Button variant="ghost" size="icon-s" onClick={onClose} data-track-name="Close" data-testid="close-button">
          <Close size="medium" data-testid="close-icon" />
        </Button>
      </div>
      <div className="w-full h-40"></div>
    </div>
  );
}

export { SuccessStep };
